// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3JhN6","footer":"ModalUpdate_footer__3h_GN"};